<template>
  <div class="hello">
    <div class="topOperation">
      <div class="top-left">
        <div>
          <ShowNavHead />
        </div>
        <div class="dateSelect" style="margin-left:30px">
          <div class="eventSelectNav">
            <div class="eventType" v-for="(event,index) in list" :key="index" v-bind:class="{selected:isActive==index}" @click="checkItem(event,index)">{{event.name}}</div>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button type="text" @click="dropDownScreen" style="margin-right:20px">
          <img src="../../assets/employee/images/screen.png" />
          <span>筛选</span>
        </el-button>
      </div>
      <!-- 筛选下拉框 -->
      <div class="dropDownScreen" v-show="showDropScreen==1">
        <div  class="inputs">
          <div class="formScreenInput" v-if="isActive==0">
            <div>导入名称</div>
            <el-input size="small" v-model="infoQuery.strobjname" placeholder="请输入导入名称"></el-input>
          </div>
          <div class="formScreenInput" v-if="isActive!=0">
            <div>导入名称</div>
            <el-input size="small" v-model="expQuery.custname" placeholder="请输入导入名称"></el-input>
          </div>
          <div class="timeip formScreenInput">
            <div>操作时间</div>
            <el-date-picker style="width:300px!important" v-model="infoQuery.impdate" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </div>
          <!-- <div class="formScreenInput" v-if="isActive==0">
            <div>导入人</div>
            <el-input size="small" v-model="infoQuery.strusername" clearable placeholder="请输入导入人"></el-input>
            <el-select
              v-model="infoQuery.druserId" filterable clearable
              placeholder="请选择导入人"
            >
              <el-option
                v-for="(item, index) in memberList"
                :key="index"
                :label="item.Username"
                :value="item.Userid">
              </el-option>
            </el-select>
          </div> -->
        </div>
        <div class="drop-footer">
          <button class="clear" style="margin-right:10px" @click="resetHandle">清空</button>
          <button class="search" @click="searchHandle">搜索</button>
          <button class="clear" @click="showDropScreen=-1">关闭</button>
        </div>
      </div>
    </div>
    <importRecord v-if="showPage==0" ref="importRecord"></importRecord>
    <exportRecord v-else :custname="custname" :qStstus="qStstus" ref="exportRecord"></exportRecord>
  </div>
</template>

<script>
import xz from "./../../common";
import importRecord from "./components/resImportRecord.vue";
import exportRecord from "./components/resExportRecord.vue";
export default {
  components: {
    importRecord,
    exportRecord
  },
  name: "resRecord",
  data() {
    return {
      //文件是否已上传
      isFileSuccess: false,
      custname: '',
      //根据qStstus值查看导出列表还是最后一条导出记录
      qStstus: '',
      opType: "import",
      isActive: 0,
      list: [
        {
          name: "导入记录",
          value: "import"
        },
        {
          name: "导出记录",
          value: "export"
        }
      ],
      showPage: 0,
      //下拉筛选
      showDropScreen: -1,
      //项目名称
      objname: '',
      //时间范围
      impdate: [],
      //开始时间
      startDate: '',
      //结束时间
      endDate: '',
      infoQuery: {
        pagecount: 10,
        currpage: 1,
        strOperType:'',//待面试批量导入 待入职批量导入 入职批量导入  离职批量导入
        excelname: '',
        tableid: "JB_busi_PsnBaseImp",
        datestart: '',
        dateend: '',
        strobjname:'',
        impdate: '',
        druserId: ''
      },
      expQuery: {
        pagecount: 10,
        currpage: 1,
        tableid: "JB_emp_UserBase,JB_busi_PsnBase,JB_busi_PsnBaseStatus,JB_busi_PsnBaseStatistics,JB_emp_PsnStatus,JB_emp_UserBaseerr,JB_busi_PsnBaseImperr,JB_emp_UserBaseout",
        custname: '',
        datestart: '',
        dateend: '',
        impdate: ''
      },
      // 导入人
      memberList: []
    };
  },
  created() {
    if (window.localStorage.getItem('page')) {
      this.infoQuery.pagecount = window.localStorage.getItem('page');
    }
    let q = this.$route.query;
    // console.log('q',q)
    if (q.isActive) {
      this.isActive = q.isActive;
      this.showPage = q.showPage;
      this.custname = q.custname;
      this.qStstus = q.qStstus;
    }
    if(q.activeTab){//判断从哪个页面过来
      if(q.activeTab == 'second'){
        this.infoQuery.tableid = 'JB_emp_PsnStatusDms'
        this.infoQuery.strOperType = '待面试批量导入'
      }else if(q.activeTab == 'third'){
        this.infoQuery.tableid = 'JB_emp_UserBaseSimple,JB_emp_UserBaseMainte,JB_emp_UserBase'
        this.infoQuery.strOperType = '入职批量导入'
      }else if(q.activeTab == 'four'){
        this.infoQuery.tableid = 'JB_emp_UserBaseDepart'
        this.infoQuery.strOperType = '离职批量导入'
      }else{
        this.infoQuery.tableid = 'JB_busi_PsnBaseImp'
        this.infoQuery.strOperType = ''
      }
    }else{
      this.infoQuery.tableid = 'JB_busi_PsnBaseImp'
      this.infoQuery.strOperType = ''
    }
  },
  methods: {//搜索
    searchHandle() {
      if (this.infoQuery.impdate === undefined || this.infoQuery.impdate === null) {
        this.infoQuery.impdate = [];
        this.infoQuery.datestart = '';
        this.infoQuery.dateend = '';
        this.expQuery.impdate = [];
        this.expQuery.datestart = '';
        this.expQuery.dateend = ''
      }
      if (this.infoQuery.impdate.length > 0) {
        this.infoQuery.datestart = this.infoQuery.impdate[0];
        this.infoQuery.dateend = this.infoQuery.impdate[1];
        this.expQuery.impdate = this.infoQuery.impdate;
        this.expQuery.datestart = this.infoQuery.impdate[0];
        this.expQuery.dateend = this.infoQuery.impdate[1]
      }
      if (this.showPage == 0) {
        // console.log('infoQuery',this.infoQuery)
        this.infoQuery.currpage = 1;
        let query1 = this.$refs.importRecord.infoQuery;
        this.infoQuery.tableid = query1.tableid
        this.infoQuery.strOperType = query1.strOperType
        this.$refs.importRecord.getOpeRecord(this.infoQuery);
      } else {
        // console.log('exportRecord',this.infoQuery)
        this.expQuery.currpage = 1;
        this.$refs.exportRecord.getExportRecord(this.expQuery);
      }
      this.showDropScreen = -1
    },
    //清空
    resetHandle() {
      this.infoQuery.currpage = 1
      this.infoQuery.pagecount = 10
      this.infoQuery.strobjname = ''
      this.infoQuery.dateend = ''
      this.infoQuery.datestart = ''
      this.infoQuery.impdate = []
      this.expQuery = {
        pagecount: 10,
        currpage: 1,
        tableid: "JB_emp_UserBase,JB_busi_PsnBase,JB_busi_PsnBaseStatus,JB_busi_PsnBaseStatistics,JB_emp_PsnStatus,JB_emp_UserBaseerr,JB_busi_PsnBaseImperr,JB_emp_UserBaseout",
        custname: '',
        datestart: '',
        dateend: ''
      }
      // this.infoQuery = this.$options.data.call(this).infoQuery;
    },
    //筛选下拉
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1
      }
    },
    //切换
    checkItem(event, index) {
      this.isActive = index;
      this.opType = event.value;
      (this.opType == "import") ? (this.showPage = 0) : (this.showPage = 1);
    }
  }
}
</script>


<style scoped>
.top-right .el-button--text {
  padding: 7px 10px;
  border: solid 1px #19bd92;
  font-size: 12px;
  color: #19bd92;
  border-radius: 4px;
  background-color: #fff;
}
.top-right .el-button--text img {
  vertical-align: sub;
}
</style>
<style >
.timeip .el-date-editor .el-range-separator {
  line-height: 24px;
}
.operationRecordTable .el-table td {
  padding: 5px 0;
}
.operationRecordTable .el-table th {
  padding: 10px 0;
}
.screenInput .el-input {
  width: 70%;
  margin-left: 5px;
}
.formScreenInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.formScreenInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.timeip .el-input__icon {
  margin-top: 3px !important;
  height: 32px;
  line-height: 32px;
}
.timeip .el-date-editor .el-range__icon {
  margin-top: 0px !important;
}
</style>